import { ProductRequestApprovalStatus } from "../enums/product-request-approval-status";
import { ProductRequest } from "../models/ProductRequest";

export function getApprovedProductRequestItemCount(productRequest: ProductRequest): number {
    return productRequest.items.filter(item => [
        ProductRequestApprovalStatus.APPROVED, 
        ProductRequestApprovalStatus.NOT_REQUIRED
    ].includes(item.approvalStatus)).length;
}